module.exports = __webpack_public_path__ + "media/images/background-5f2350916e38545cf67e778fbcd6d456.jpg";